import { render, staticRenderFns } from "./salaryItem-detail.vue?vue&type=template&id=7faddaee&scoped=true&"
import script from "./salaryItem-detail.vue?vue&type=script&lang=js&"
export * from "./salaryItem-detail.vue?vue&type=script&lang=js&"
import style0 from "./salaryItem-detail.vue?vue&type=style&index=0&id=7faddaee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faddaee",
  null
  
)

export default component.exports